<div class="layout-boxed content">
  <div class="row articles-section">
    <app-article
      *ngFor="let article of articles"
      [article]="article"
      class="col-sm-3"
    ></app-article>
  </div>
</div>
